import React from "react"
import { Link } from "react-router-dom"

const SectionSeven = () => {
  return (
    <div className="h-70vh mobiles:relative mobiles:top-96 mobiles:transform mobiles:translate-y-10 gift-bottom text-center pb-20">
      <div className="global-container h-full flex justify-center items-center">
        <div>
          <h6>What are you waiting for?</h6>
          <h4 className="text-4xl mobiles:hidden mt-4">
            Getting started is
            <span className="header-bg-design"> easy</span>!
          </h4>
          <h4 className="text-4xl hidden mobiles:block mt-4">
            Getting started is <br />
            <span className="header-bg-design"> easy</span>!
          </h4>
          <div className="mt-8 flex justify-center">
            <Link
              to="/sign-up"
              className=" py-2.5 px-11 mr-2 mobiles:px-5 bg-sbg-pink border border-transparent text-transparent rounded-md text-base text-white "
            >
              Sign up
            </Link>

            <Link
              // to="/sign-up"
              className=" py-2.5 px-11 ml-2 mobiles:px-5 border border-sbg-light-green text-sbg-light-green rounded-md text-base"
            >
              Learn More
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SectionSeven
